import React from "react";
import { Link } from "../components/PageLink";
import { Helmet } from "react-helmet-async";
import { CLUSTERS, SERVICES } from "../lib/areas";

const NotFound: React.FC = () => (
  <>
    <Helmet>
      <title>J&amp;S Audio Video Solutions – Page Not Found</title>
      <meta name="description" content="This page could not be found. Browse J&S Audio Video Solutions services and service areas, or contact us for help." />
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <section className="not-found" data-testid="page-not-found">
      <div className="not-found-inner">
        <span className="eyebrow">404</span>
        <h1>404: Page not found</h1>
        <p className="lead mt-3">
          Try one of the links below, or just call us at{" "}
          <a href="tel:+15084500490" style={{ color: "var(--color-secondary)" }}>508-450-0490</a>.
        </p>

        <div style={{ marginTop: "var(--space-5)", display: "flex", gap: "var(--space-3)", justifyContent: "center", flexWrap: "wrap" }}>
          <Link to="/" className="btn">Back to Home</Link>
          <Link to="/contact" className="btn btn-outline-dark">Contact Us</Link>
        </div>

        <div className="helpful-grid">
          <div>
            <h4 style={{ color: "var(--color-secondary)", marginBottom: "var(--space-2)" }}>Services</h4>
            <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: "0.4rem" }}>
              {SERVICES.map((s) => (
                <li key={s.slug}><Link to={s.path}>{s.title}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 style={{ color: "var(--color-secondary)", marginBottom: "var(--space-2)" }}>Service Areas</h4>
            <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: "0.4rem" }}>
              {CLUSTERS.map((c) => (
                <li key={c.slug}><Link to={c.path}>{c.name}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
